import { getApiClient } from "../libs/ApiClient";

export type FeatureToggle = {
    accountsForKpiDashboard: string[];
};

export async function getFeatureToggleConfig(
  getAccessToken: () => Promise<string>,
  signal?: AbortSignal
) {
  const client = await getApiClient(getAccessToken);
  const response = await client.get<FeatureToggle>(
    `/accounts/v2/feature-toggle`,
    { signal: signal }
  );
  return response.data;
}